import React from 'react';
import { Link } from 'react-router-dom';

export default function ContentGym() {

    return (
        <div className="content-gym" data-aos="fade-up" data-aos-delay="50">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-6 gym-container-text">
                        <h2>Academias</h2>
                        <p>Atualmente contamos com <span>6 Unidades</span>: 1 Londres, 1 Barra, 1 Portugal e 3 Petrópolis.</p>
                        <p>Todas com uma <span>linda estrutura de box</span> e academia, enquanto equipadas com os <span>melhores equipamentos</span> que o mercado tem para oferecer.</p>
                    </div>
                    <div className="col-md-6 gym-container-img">
                        
                    </div>
                    <div className="col-md-12 text-center mt-5">
                        <Link to="/franquia" className="btn-border">Quero ter minha própria BRUK</Link>
                    </div>
                </div>
            </div>
        </div>
    );
}